import { render } from "./SelectInput.vue?vue&type=template&id=6358e060"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"
script.render = render

export default script